import request from '@/api/request'
//登录
export function login(data) {
  return request({
    url: `/education/sysUser/login`,
    method: 'post',
    data
  })
}
// 获取用户信息
export function userInfo() {
  return request({
    url: `/education/profile/user`,
    method: 'get'
  })
}

// 分享卡片
export function getSing(url) {
  return request({
    url: `/education/wxCard/getSing?url=${url}`,
    method: 'get'
  })
}